import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {Backend} from "@generated-backend-types";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import EmailTypeEnum = Backend.App.Enums.Administrations.EmailTypeEnum;
import EmailPlaceholderEnum = Backend.App.Enums.Administrations.EmailPlaceholderEnum;
import {CoreModule} from "../../../core.module";


@Component({
    selector: 'app-email-placeholders',
    templateUrl: './email-placeholders.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CoreModule],
    standalone: true
})
export class EmailPlaceholdersComponent {
  @Input() public emailType?: EmailTypeEnum;
  @Input() public templateMode = false;
  public emailPlaceholders = EmailPlaceholderEnum;
  public emailTypes = EmailTypeEnum;

  public copyPlaceholderToClipboard(selectedPlaceholder: EmailPlaceholderEnum): void {
    this.toastr.success(this.translateService.instant('shared.components.email_placeholder.copy_to_clipboard_success'))
    navigator.clipboard.writeText('{{-- ' + selectedPlaceholder + ' --}}');
  }

  constructor(private toastr: ToastrService, private translateService: TranslateService) {
  }
}
